var _path, _path2, _g, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26086 17.5H5.45421C3.5501 17.5 2.00049 16.0082 2.00049 14.1737V5.827C2.00049 3.9925 3.5501 2.5 5.45421 2.5H9.25229C11.1579 2.5 12.7083 3.9925 12.7083 5.827V6.526C12.7083 6.8365 12.4466 7.0885 12.124 7.0885C11.8015 7.0885 11.5397 6.8365 11.5397 6.526V5.827C11.5397 4.612 10.5136 3.625 9.25229 3.625H5.45421C4.19441 3.625 3.16913 4.612 3.16913 5.827V14.1737C3.16913 15.388 4.19441 16.375 5.45421 16.375H9.26086C10.5168 16.375 11.5397 15.391 11.5397 14.182V13.4748C11.5397 13.1643 11.8015 12.9123 12.124 12.9123C12.4466 12.9123 12.7083 13.1643 12.7083 13.4748V14.182C12.7083 16.012 11.1611 17.5 9.26086 17.5Z",
    fill: "#A0ACB9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_358_7779",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 12,
    height: 2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45068 9.4375H18.0003V10.5625H7.45068V9.4375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_358_7779)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4161 10.5625H8.035C7.71246 10.5625 7.45068 10.3105 7.45068 10C7.45068 9.6895 7.71246 9.4375 8.035 9.4375H17.4161C17.7386 9.4375 18.0004 9.6895 18.0004 10C18.0004 10.3105 17.7386 10.5625 17.4161 10.5625Z",
    fill: "#A0ACB9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_358_7779",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 7,
    width: 5,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5513 7.25146H18.0006V12.7495H14.5513V7.25146Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_358_7779)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1354 12.7495C14.9858 12.7495 14.8354 12.6948 14.7217 12.5838C14.4942 12.3633 14.495 12.0078 14.7233 11.7888L16.5884 10L14.7233 8.21203C14.495 7.99303 14.4934 7.63753 14.7217 7.41703C14.9492 7.19653 15.3185 7.19653 15.5475 7.41553L17.8287 9.60178C17.9394 9.70678 18.0009 9.85078 18.0009 10C18.0009 10.1493 17.9394 10.2933 17.8287 10.3983L15.5475 12.5853C15.4338 12.6948 15.2842 12.7495 15.1354 12.7495Z",
    fill: "#A0ACB9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6e01cc5c98e7b7557ef6e7c51ddf14bc.svg";
export { ForwardRef as ReactComponent };